module.exports = __webpack_public_path__ + "5b509003df44d23da0587bca7b950709.gif";